import { render } from "./FormMessage.vue?vue&type=template&id=0b0d18a3&ts=true"
import script from "./FormMessage.vue?vue&type=script&lang=ts"
export * from "./FormMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__